<template>
  <div class="dashboard-container">
    <div class="top-option-container">
      <div class="top-list-container">
        <div class="label-top-list">
          <label>Period</label>
        </div>
        <b-form-select
          :options="yearGenerate"
          v-model="yearFrom"
          class="top-list-menu"
        ></b-form-select>
        <label for="">Compare to : </label>
        <b-form-select
          :options="yearGenerate"
          v-model="yearTo"
          class="top-list-menu"
        ></b-form-select>
      </div>
      <b-button
        @click="getSpmData"
        :disabled="yearFrom <= yearTo ? false : true"
      >
        Submit
      </b-button>
      <b-button
        @click="$router.push('/dashboarddetailspm', () => {})"
        class="ml-2"
        :disabled="$store.state.spmDashboardDetail ? false : true"
      >
        Detail
      </b-button>
    </div>
    <div class="spm-chart-container">
      <SpmCompany :spm-global="checkSpm" v-if="renderComp" />
      <SpmSummary :spm-summary="checkSummary" />
    </div>
    <div class="loading-dashboard" v-if="isLoading">
      <b-spinner
        variant="primary"
        label="Spinning"
        class="loading-spinner"
      ></b-spinner>
    </div>
  </div>
</template>
<script>
import { api } from '../services/config'
import axios from 'axios'
import SpmCompany from '@/components/dashboard/spm-company.vue'
import SpmSummary from '@/components/dashboard/spm-summary.vue'
export default {
  name: 'spmDashboard',
  components: {
    SpmCompany,
    SpmSummary,
  },
  data() {
    return {
      renderComp: true,
      isLoading: false,
      yearFrom: 2019,
      yearTo: new Date().getFullYear(),
      spmData: [],
      summaryData: [],
    }
  },
  created() {
    const self = this
    self.$store.dispatch('toggleSidebar', false)
    self.yearGenerate
  },
  computed: {
    checkSpm: {
      get: function() {
        return this.spmData
      },
    },
    checkSummary: {
      get: function() {
        return this.summaryData
      },
    },
    yearGenerate: {
      get: function() {
        let currentYear = new Date().getFullYear()
        let totalYear = currentYear - 2010
        let year = []
        for (let i = 0; i <= totalYear; i++) {
          year.push(currentYear - i)
        }
        return year
      },
    },
  },
  methods: {
    reRender() {
      this.renderComp = false

      this.$nextTick(() => {
        this.renderComp = true
      })
    },
    stopLoading() {
      this.isLoading = false
    },
    runLoading() {
      this.isLoading = true
    },
    async getSpmData() {
      try {
        if (this.yearFrom <= this.yearTo) {
          this.$ga.event({
            eventCategory: 'Dashboard SPM',
            eventAction: 'click',
            eventLabel: `SUBMIT PERIOD_FROM=${this.yearFrom}&PERIOD_TO=${this.yearTo}`,
          })
          await this.runLoading()
          const uri = `${api}/api/v1/dashboard/spm?PERIOD_FROM=${this.yearFrom}&PERIOD_TO=${this.yearTo}`
          const { data } = await axios({
            method: 'GET',
            url: uri,
          })
          if (data && data.status == 'success' && data.data) {
            let spmItems = {}
            let global = Object.values(data.data.global[0])
            let summary = Object.values(data.data.summary[0])

            this.summaryData = summary
            this.spmData = global
            const spmData = {
              spmDetail: Object.values(data.data.detail[0]),
              spmCompany: global,
              spmSummary: summary,
              spmFrom: this.yearFrom,
              spmTo: this.yearTo,
            }

            await this.$store.commit('SET_SPM_DASHBOARD', spmData)
            await this.reRender()
            await this.stopLoading()
          } else {
            const spmData = {
              spmDetail: null,
              spmCompany: null,
              spmSummary: null,
              spmFrom: null,
              spmTo: null,
            }
            await this.$store.commit('SET_SPM_DASHBOARD', spmData)
            await this.stopLoading()
          }
        }
      } catch (error) {
        this.stopLoading()
      }
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/scss/components/dashboard.scss';
</style>
